export const ClientHeroText = {
  en: {
    preTitle: "",
    name: "Community",
    subtitle: "Business Coach • Advisor • Founder of Maria Advisory",
    shortIntro:
      "Helping business owners grow with clarity, structure, and measurable results.",
  },

  vi: {
    preTitle: "",
    name: "Cộng đồng",
    subtitle:
      "Chuyên gia huấn luyện kinh doanh • Cố vấn • Nhà sáng lập Maria Advisory",
    shortIntro:
      "Đồng hành cùng doanh nghiệp phát triển với chiến lược rõ ràng, cấu trúc và hiệu quả đo lường được.",
  },
};

export const quoteClientText = {
  en: {
    title:
      "We are proud to work with business owners, SMEs, and professionals who are committed to growth, improvement, and long-term success",
    body: "",
  },

  vi: {
    title:
      "Tại Maria Advisory, tăng trưởng không dựa trên giả định. Mọi thứ được đo lường, quản lý và tạo ra kết quả.",
    body: "Nếu bạn sẵn sàng tăng trưởng bền vững thông qua chiến lược rõ ràng, thực thi kỷ luật và các quyết định dựa trên ROI, Maria Pooley và Maria Advisory sẽ mang đến chuyên môn, cấu trúc và sự đồng hành để hỗ trợ giai đoạn phát triển tiếp theo của bạn.",
  },
};

export const missionClientText = {
  en: {
    title: "Collaboration, Marketing Initiatives & Networking Opportunities",

    description:
      "We value the strong relationships we have built with our partners who continuously support our vision through collaboration, marketing initiatives, networking opportunities, and long-term strategic development.",
  },

  vi: {
    title: "Hợp Tác, Hoạt Động Marketing & Cơ Hội Kết Nối Doanh Nghiệp",

    description:
      "Chúng tôi trân trọng những mối quan hệ bền vững đã xây dựng cùng các đối tác luôn đồng hành và hỗ trợ tầm nhìn của chúng tôi thông qua hợp tác chiến lược, các hoạt động marketing, cơ hội kết nối doanh nghiệp và định hướng phát triển lâu dài.",
  },
};

export const ClientandPartnerText = {
  en: {
    title: "Our Clients",
    secondTitle: "Success Stories",

    intro: [
      "We are proud to work with business owners, SMEs, and professionals who are committed to growth, improvement, and long-term success. Through our coaching, consulting, and business development programs, many of our clients have successfully transformed their mindset, strengthened their leadership skills, and improved the way they manage their businesses and teams.",
      "Our clients have gained greater clarity, stronger business strategies, improved staff performance, and more effective systems that support sustainable growth. By implementing practical solutions and growth-focused strategies, they have been able to increase productivity, improve operational efficiency, build stronger workplace cultures, and achieve better profitability.",
    ],

    highlight:
      "We believe that real business growth starts with the right mindset, strong leadership, and the ability to adapt, innovate, and take action with confidence.",

    body: [
      "Our success stories are built through strong partnerships with business owners, SMEs, and professionals who were ready to transform their businesses and achieve greater results. Through our coaching, consulting, and strategic development programs, many of our clients have successfully changed their mindset, improved leadership capabilities, strengthened team management, and created more productive business operations.",
      "By implementing practical business strategies, effective systems, and growth-focused planning, our clients have achieved improved staff performance, stronger workplace culture, increased efficiency, and greater profitability. Their success reflects the power of clear direction, continuous improvement, and the confidence to grow beyond challenges.",
    ],

    closingTitle:
      "We are proud to support businesses on their journey from uncertainty and survival toward sustainable growth, stronger performance, and long-term success.",
    closingText: "",
    cta: "",
  },

  vi: {
    title: "Khách Hàng Của Chúng Tôi",
    secondTitle: "Câu Chuyện Thành Công",

    intro: [
      "Chúng tôi tự hào đồng hành cùng các chủ doanh nghiệp, doanh nghiệp vừa và nhỏ (SMEs) và các chuyên gia luôn cam kết phát triển, cải thiện và hướng đến thành công bền vững. Thông qua các chương trình coaching, tư vấn và phát triển doanh nghiệp, nhiều khách hàng của chúng tôi đã thay đổi tư duy, nâng cao kỹ năng lãnh đạo và cải thiện cách quản lý doanh nghiệp cũng như đội ngũ của mình.",

      "Khách hàng của chúng tôi đạt được sự rõ ràng hơn trong chiến lược kinh doanh, cải thiện hiệu suất nhân sự và xây dựng các hệ thống vận hành hiệu quả hỗ trợ tăng trưởng bền vững. Bằng việc áp dụng các giải pháp thực tiễn và chiến lược tăng trưởng phù hợp, họ đã nâng cao năng suất, tối ưu vận hành, xây dựng văn hoá doanh nghiệp tích cực và cải thiện lợi nhuận.",
    ],

    highlight:
      "Chúng tôi tin rằng sự phát triển thực sự của doanh nghiệp bắt đầu từ tư duy đúng đắn, khả năng lãnh đạo mạnh mẽ và sự tự tin để thích nghi, đổi mới và hành động.",

    body: [
      "Những câu chuyện thành công của chúng tôi được xây dựng từ sự hợp tác chặt chẽ với các chủ doanh nghiệp, SMEs và các chuyên gia sẵn sàng chuyển đổi doanh nghiệp và đạt được kết quả lớn hơn. Thông qua các chương trình coaching, tư vấn và phát triển chiến lược, nhiều khách hàng đã thay đổi tư duy, nâng cao năng lực lãnh đạo, cải thiện quản lý đội ngũ và xây dựng hoạt động kinh doanh hiệu quả hơn.",

      "Bằng cách triển khai các chiến lược kinh doanh thực tiễn, hệ thống vận hành hiệu quả và kế hoạch tăng trưởng rõ ràng, khách hàng của chúng tôi đã cải thiện hiệu suất nhân sự, xây dựng văn hoá doanh nghiệp mạnh mẽ hơn, tăng hiệu quả vận hành và nâng cao lợi nhuận. Thành công của họ phản ánh sức mạnh của định hướng rõ ràng, sự cải tiến liên tục và tinh thần vượt qua thử thách để phát triển.",
    ],

    closingTitle:
      "Chúng tôi tự hào đồng hành cùng các doanh nghiệp trên hành trình vượt qua sự bất ổn và giai đoạn tồn tại để hướng đến tăng trưởng bền vững, hiệu suất mạnh mẽ hơn và thành công lâu dài.",
    closingText: "",
    cta: "",
  },
};

export const ClientDirectoryData = {
  en: {
    categories: [
      "All",
      "Restaurant & Café",
      "Nail & Beauty",
      "Retail",
      "Property & Investment",
      "Professional Services",
    ],

    clients: [
      {
        name: "Pho Hanoi",
        category: "Restaurant & Café",
        location: "Auckland",
      },
      {
        name: "Golden Dragon Restaurant",
        category: "Restaurant & Café",
        location: "Sydney",
      },

      {
        name: "Lily's Nail Bar",
        category: "Nail & Beauty",
        location: "Sydney",
      },
      {
        name: "Viet Beauty Studio",
        category: "Nail & Beauty",
        location: "Auckland",
      },

      {
        name: "Saigon Boutique",
        category: "Retail",
        location: "Wellington",
      },
      {
        name: "Pacific Trade Co.",
        category: "Retail",
        location: "Brisbane",
      },

      {
        name: "ANZ Property Group",
        category: "Property & Investment",
        location: "Auckland",
      },
      {
        name: "NZ Home Investments",
        category: "Property & Investment",
        location: "Wellington",
      },

      {
        name: "Vertex Accounting",
        category: "Professional Services",
        location: "Christchurch",
      },
      {
        name: "Southern Legal Advisory",
        category: "Professional Services",
        location: "Melbourne",
      },
    ],
  },

  vi: {
    categories: [
      "Tất cả",
      "Nhà hàng & Café",
      "Nail & Làm đẹp",
      "Bán lẻ",
      "Bất động sản",
      "Dịch vụ chuyên nghiệp",
    ],

    clients: [
      {
        name: "Phở Hà Nội",
        category: "Nhà hàng & Café",
        location: "Auckland",
      },
      {
        name: "Golden Dragon Restaurant",
        category: "Nhà hàng & Café",
        location: "Sydney",
      },

      {
        name: "Lily's Nail Bar",
        category: "Nail & Làm đẹp",
        location: "Sydney",
      },
      {
        name: "Viet Beauty Studio",
        category: "Nail & Làm đẹp",
        location: "Auckland",
      },

      {
        name: "Saigon Boutique",
        category: "Bán lẻ",
        location: "Wellington",
      },
      {
        name: "Pacific Trade Co.",
        category: "Bán lẻ",
        location: "Brisbane",
      },

      {
        name: "ANZ Property Group",
        category: "Bất động sản",
        location: "Auckland",
      },
      {
        name: "NZ Home Investments",
        category: "Bất động sản",
        location: "Wellington",
      },

      {
        name: "Vertex Accounting",
        category: "Dịch vụ chuyên nghiệp",
        location: "Christchurch",
      },
      {
        name: "Southern Legal Advisory",
        category: "Dịch vụ chuyên nghiệp",
        location: "Melbourne",
      },
    ],
  },
};

export const clientTestimonials = {
  en: {
    smallTitle: "Client Results",
    title: "Real Stories. Real Business Growth.",

    description:
      "Every business transformation begins with clarity, leadership, and the willingness to grow. Here are some experiences shared by business owners and professionals who have worked with Maria Advisory.",

    testimonials: [
      {
        category: "NAIL & BEAUTY",
        result: "+$80K revenue",
        period: "in 18 weeks",
        stars: 5,
        name: "Ann & Jack",
        role: "Nail Salon Owners",

        content: [
          "Hello Maria, I’m sending you my feedback on the recent course. I truly want to thank you and the High-Performance team for providing such valuable, practical knowledge that can be applied immediately in business.",

          "After 18 weeks of training, my nail salon’s turnover increased by more than $80,000, and our retail sales also showed clear growth.",

          "More importantly, I was able to build a better management system, work more effectively with my team, and gain a clear direction for the future development of the business.",
        ],
      },

      {
        category: "SMALL BUSINESS",
        result: "3 free days",
        period: "every week",
        stars: 5,
        name: "Hanna",
        role: "Business Owner",

        content: [
          "Hi Maria, I have changed my mindset of managing my business and my people, and that works very well.",

          "My business is now running properly, and I no longer need to be involved in too many detailed daily tasks.",

          "I can now enjoy 3 days free each week for myself and for developing my other interests. Thank you very much.",
        ],
      },

      {
        category: "LEADERSHIP",
        result: "Better teamwork",
        period: "within months",
        stars: 5,
        name: "Steven",
        role: "Business Professional",

        content: [
          "Maria, you have completely upscaled my mindset in managing people.",

          "I never realised that learning to understand others could improve the way I work with partners and staff.",

          "For many years I struggled with communication and relationships in the workplace, but today things are much better because I have learnt the right skills.",

          "Our communication, teamwork, and relationships have improved significantly. Thank you.",
        ],
      },
    ],
  },

  vi: {
    smallTitle: "Chia Sẻ Từ Khách Hàng",
    title: "Câu Chuyện Thực Tế. Tăng Trưởng Thực Sự.",

    description:
      "Mỗi sự chuyển đổi trong doanh nghiệp đều bắt đầu từ sự rõ ràng, khả năng lãnh đạo và tinh thần sẵn sàng phát triển. Dưới đây là những chia sẻ từ các chủ doanh nghiệp và chuyên gia đã đồng hành cùng Maria Advisory.",

    testimonials: [
      {
        category: "NAIL & LÀM ĐẸP",
        result: "+80.000 USD",
        period: "sau 18 tuần",
        stars: 5,
        name: "Ann & Jack",
        role: "Chủ Tiệm Nail",

        content: [
          "Chào Maria, tôi muốn gửi phản hồi về khóa học vừa qua. Tôi thật sự cảm ơn Maria và đội ngũ High-Performance vì đã mang đến những kiến thức vô cùng giá trị và thực tiễn, có thể áp dụng ngay vào kinh doanh.",

          "Sau 18 tuần đào tạo, doanh thu của tiệm nail của chúng tôi đã tăng hơn 80.000 đô la, đồng thời doanh số bán lẻ cũng tăng trưởng rõ rệt.",

          "Quan trọng hơn, tôi đã xây dựng được hệ thống quản lý tốt hơn, làm việc hiệu quả hơn với đội ngũ và có định hướng rõ ràng hơn cho sự phát triển tương lai của doanh nghiệp.",
        ],
      },

      {
        category: "DOANH NGHIỆP NHỎ",
        result: "3 ngày tự do",
        period: "mỗi tuần",
        stars: 5,
        name: "Hanna",
        role: "Chủ Doanh Nghiệp",

        content: [
          "Chào Maria, tôi đã thay đổi tư duy trong việc quản lý doanh nghiệp và con người của mình, và điều đó mang lại hiệu quả rất tốt.",

          "Doanh nghiệp của tôi hiện vận hành ổn định hơn và tôi không còn phải tham gia quá nhiều vào những công việc chi tiết hàng ngày.",

          "Giờ đây tôi có thể dành 3 ngày mỗi tuần cho bản thân và phát triển những sở thích khác của mình. Cảm ơn Maria rất nhiều.",
        ],
      },

      {
        category: "LÃNH ĐẠO",
        result: "Đội ngũ gắn kết",
        period: "chỉ sau vài tháng",
        stars: 5,
        name: "Steven",
        role: "Chuyên Gia Kinh Doanh",

        content: [
          "Maria, chị đã giúp tôi nâng cấp hoàn toàn tư duy trong việc quản lý con người.",

          "Trước đây tôi không nhận ra rằng việc học cách thấu hiểu người khác lại có thể cải thiện cách làm việc với đối tác và nhân viên.",

          "Trong nhiều năm tôi đã gặp khó khăn trong giao tiếp và xây dựng mối quan hệ trong công việc, nhưng hôm nay mọi thứ đã tốt hơn rất nhiều vì tôi đã học được những kỹ năng phù hợp.",

          "Khả năng giao tiếp, làm việc nhóm và các mối quan hệ của chúng tôi đã cải thiện đáng kể. Xin cảm ơn.",
        ],
      },
    ],
  },
};

export const ClientandPartnerButton = {
  en: {
    book: "Become Our Partner",
  },

  vi: {
    book: "Trở Thành Đối Tác Của Chúng Tôi",
  },
};

export const OurPartnersText = {
  en: {
    title: "Our partners & affiliated organizations",
    secondTitle: "Become Our Partner",

    intro: [
      "We value the strong relationships we have built with our partners who continuously support our vision through collaboration, marketing initiatives, networking opportunities, and long-term strategic development.",

      "Together, we work to create stronger business connections, support SME growth, and contribute to building a more connected and successful business community across New Zealand and Australia.",
    ],

    highlight:
      "We believe that strong partnerships create stronger communities, better opportunities, and a brighter future for businesses and professionals alike.",

    body: [
      "Join us in building a stronger and more connected business community. We welcome strategic partners, industry professionals, organisations, and businesses who share our vision for growth, collaboration, and long-term success.",

      "Whether through networking, marketing collaboration, events, training, or business development initiatives, we believe great partnerships create greater opportunities for everyone.",
    ],

    closingTitle:
      "Connect with us today and explore how we can grow, support, and succeed together.",

    closingText: "",
    cta: "",
  },

  vi: {
    title: "Các đối tác và tổ chức liên kết của chúng tôi",
    secondTitle: "Trở Thành Đối Tác",

    intro: [
      "Chúng tôi trân trọng những mối quan hệ bền vững đã xây dựng cùng các đối tác luôn đồng hành và hỗ trợ tầm nhìn của chúng tôi thông qua hợp tác chiến lược, các hoạt động marketing, cơ hội kết nối doanh nghiệp và định hướng phát triển lâu dài.",

      "Cùng nhau, chúng tôi tạo ra những kết nối kinh doanh mạnh mẽ hơn, hỗ trợ sự phát triển của các doanh nghiệp vừa và nhỏ (SMEs), đồng thời góp phần xây dựng một cộng đồng doanh nghiệp gắn kết và thành công hơn tại New Zealand và Australia.",
    ],

    highlight:
      "Chúng tôi tin rằng những mối quan hệ hợp tác mạnh mẽ sẽ tạo nên cộng đồng vững mạnh hơn, nhiều cơ hội tốt hơn và một tương lai tươi sáng hơn cho doanh nghiệp cũng như các chuyên gia.",

    body: [
      "Hãy cùng chúng tôi xây dựng một cộng đồng doanh nghiệp mạnh mẽ và kết nối hơn. Chúng tôi chào đón các đối tác chiến lược, chuyên gia trong ngành, tổ chức và doanh nghiệp có chung tầm nhìn về tăng trưởng, hợp tác và thành công lâu dài.",

      "Dù thông qua networking, hợp tác marketing, sự kiện, đào tạo hay các chương trình phát triển doanh nghiệp, chúng tôi tin rằng những mối quan hệ hợp tác tuyệt vời sẽ tạo ra nhiều cơ hội lớn hơn cho tất cả mọi người. ",
    ],

    closingTitle:
      "Hãy kết nối với chúng tôi ngay hôm nay để cùng phát triển, hỗ trợ và thành công.",

    closingText: "",

    cta: "",
  },
};

export const ClientDirectoryDataPartner = {
  en: {
    categories: [
      "All",
      "Strategic",
      "Community",
      "Network",
      "Affiliate",
      "Certified",
    ],

    clients: [
      {
        name: "Sunwave NZ International",
        category: "Strategic",
        location: "New Zealand",
        description: "Business Coaching & Events Partner",
        badge: "STRATEGIC",
        color: "#C82128",
        link: "https://sunwave.co.nz/",
      },

      {
        name: "HPTC Global Network",
        category: "Certified",
        location: "Global",
        description: "High Performance Coaching · Certified Program",
        badge: "CERTIFIED",
        color: "#1F436B",
        link: "https://worldathletics.org/news/news/hptc-introduction",
      },

      {
        name: "Auckland Asian Association",
        category: "Community",
        location: "Auckland",
        description: "Community · Networking · Advocacy",
        badge: "COMMUNITY",
        color: "#0F6A4A",
        link: "http://aucklandasian.org.nz/",
      },

      {
        name: "VietNZ Community Trust",
        category: "Community",
        location: "New Zealand",
        description: "Vietnamese community support NZ",
        badge: "COMMUNITY",
        color: "#0F6A4A",
        link: "https://vietnz.org/",
      },

      {
        name: "BDI Business Network",
        category: "Network",
        location: "New Zealand",
        description: "Investment & business development",
        badge: "NETWORK",
        color: "#9A7314",
        link: "https://www.facebook.com/BDInetworknz/",
      },

      {
        name: "Maria ROI Advisory",
        category: "Affiliate",
        location: "New Zealand",
        description: "Advisory services · ROI consulting",
        badge: "AFFILIATE",
        color: "#735A5A",
      },
    ],
  },

  vi: {
    categories: [
      "Tất cả",
      "Chiến lược",
      "Cộng đồng",
      "Mạng lưới",
      "Liên kết",
      "Chứng nhận",
    ],

    clients: [
      {
        name: "Sunwave NZ International",
        category: "Chiến lược",
        location: "New Zealand",
        description: "Đối tác huấn luyện doanh nghiệp và tổ chức sự kiện",
        badge: "CHIẾN LƯỢC",
        color: "#C82128",
        link: "https://sunwave.co.nz/",
      },

      {
        name: "HPTC Global Network",
        category: "Chứng nhận",
        location: "Toàn cầu",
        description: "Chương trình huấn luyện hiệu suất cao được chứng nhận",
        badge: "CHỨNG NHẬN",
        color: "#1F436B",
        link: "https://worldathletics.org/news/news/hptc-introduction",
      },

      {
        name: "Auckland Asian Association",
        category: "Cộng đồng",
        location: "Auckland",
        description: "Kết nối cộng đồng · Giao lưu · Vận động cộng đồng",
        badge: "CỘNG ĐỒNG",
        color: "#0F6A4A",
        link: "http://aucklandasian.org.nz/",
      },

      {
        name: "VietNZ Community Trust",
        category: "Cộng đồng",
        location: "New Zealand",
        description: "Hỗ trợ cộng đồng người Việt tại New Zealand",
        badge: "CỘNG ĐỒNG",
        color: "#0F6A4A",
        link: "https://vietnz.org/",
      },

      {
        name: "BDI Business Network",
        category: "Mạng lưới",
        location: "New Zealand",
        description: "Đầu tư và phát triển kinh doanh",
        badge: "MẠNG LƯỚI",
        color: "#9A7314",
        link: "https://www.facebook.com/BDInetworknz/",
      },

      {
        name: "Maria ROI Advisory",
        category: "Liên kết",
        location: "New Zealand",
        description: "Dịch vụ tư vấn · Tối ưu hiệu quả đầu tư (ROI)",
        badge: "LIÊN KẾT",
        color: "#735A5A",
      },
    ],
  },
};

export const readyToGrowCommunity = {
  en: {
    title: "Ready to join our community and grow your business?",
    subtitle: "Book a free 30-minute discovery call with Maria",
    button1: "Book a free call",
    button2: "Learn more",
  },

  vi: {
    title: "Sẵn sàng tham gia cộng đồng và phát triển doanh nghiệp?",
    subtitle: "Đặt lịch tư vấn miễn phí 30 phút cùng Maria",
    button1: "Đặt lịch miễn phí",
    button2: "Tìm hiểu thêm",
  },
};
